import { render } from "./TheoryView.vue?vue&type=template&id=3c928980&scoped=true"
import script from "./TheoryView.vue?vue&type=script&lang=js"
export * from "./TheoryView.vue?vue&type=script&lang=js"

import "./TheoryView.vue?vue&type=style&index=0&id=3c928980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c928980"]])

export default __exports__